export default {
      id: "oc-stared-usage",
      viewBox: "0 0 1025 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-stared",
      toString: function () {
        return this.url;
      }
    }